export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img08.ae49248b.jpg";